import { connect } from 'react-redux';
import { push } from 'redux-first-history';
import OnboardingLandingPage from './component';
import { acceptTerms, collectMoveInCosts } from '@rental-manager/actions/OnboardingActions';
import { closeNotification, showPageNotification } from '@common/actions/NotificationActions';
import { CONTINUE_PAYMENT_SETUP } from '@rental-manager/constants/NotificationConstants';
import paths from '@rental-manager/pathsManifest';

const mapStateToProps = (state, { propertyId }) => {
  const { propertyStatus } = state.payments.landlord.property || {};
  const { getLandlordStatusRequestStatus, getLandlordStatusMessageCode } =
    state.payments.landlord.onboarding[propertyId];
  const user = state.user;
  const currentProperty = state.payments.landlord.property.listingDetails;
  return {
    propertyStatus,
    getLandlordStatusRequestStatus,
    getLandlordStatusMessageCode,
    user,
    currentProperty,
  };
};

const mapDispatchToProps = (dispatch, { baseUrl, propertyId }) => ({
  showSetupNofication: () => dispatch(showPageNotification(CONTINUE_PAYMENT_SETUP, { propertyId, baseUrl })),
  onNext: (collectMIC) =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(acceptTerms({ propertyId })))
      .then(() => collectMIC && dispatch(collectMoveInCosts({ propertyId })))
      .then(() =>
        dispatch(
          push({
            pathname: baseUrl + paths.onboarding.checklistPage,
            search: 'acceptTerms=true',
          }),
        ),
      ),
});

export default connect(mapStateToProps, mapDispatchToProps)(OnboardingLandingPage);
